import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';

import { IExport } from '../../ImportExportModule/interfaces/IExport';
import { getServiceBaseURL } from '../common/getServiceBaseURL';
import { APIServiceEnum } from '../enums/APIServiceEnum';
import { apiPost } from '../common/apiTools';

interface IReportBody {
  type: string;
  format: string;
  knoId?: number | string;
  knoErvkId?: string;
  isChildKnoIncluded?: boolean;
  isSpecialAndMilitaryProsecutorOrgIncluded?: boolean;
  prosecutorOrgId?: number | string;
  isChildProsecutorOrgIncluded?: boolean;
  year?: number;
  month?: number;
  startDate?: string;
  endDate?: string;
  planId?: number | string;
  federalLawName?: string;
  service?: 'REPORT';
}

export async function downloadExtendedReport(body: IReportBody): Promise<IExport> {
  const lawInterface = getLawInterfaceFromStorage();
  const params = new URLSearchParams();

  params.set('isFederalLaw248', String(lawInterface === LawInterfacesEnum.FZ_248));

  return apiPost({ url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/reports?${params}`, body });
}
